export const SCALE = {
  player: { heightM: 1.8, capsuleHalfHeightM: 0.5, capsuleRadiusM: 0.4 },
  pedestrian: { minHeightM: 1.55, maxHeightM: 1.95 },
  car: { lengthM: [4.2, 5.2], widthM: [1.7, 2], heightM: [1.4, 1.8] },
  bus: { lengthM: 12, widthM: 2.55, heightM: 3.2 },
  subwayA: { lengthM: 15.5, widthM: 2.62, heightM: 3.7 },
  subwayB: { lengthM: 18.3, widthM: 3, heightM: 3.7 },
  mainline: { lengthM: 25.9, widthM: 3.2, heightM: [4, 4.5] },
  roadLane: { defaultWidthM: 3.2 },
  occupiedFloor: { minHeightM: 2.7, maxHeightM: 4.5 },
} as const;

export const WORLD_SEED = "voxcity-manhattan-v1";
